import { render, staticRenderFns } from "./PayslipHourlyPolicyAssignUserDetailsView.vue?vue&type=template&id=52048cf8&"
import script from "./PayslipHourlyPolicyAssignUserDetailsView.vue?vue&type=script&lang=js&"
export * from "./PayslipHourlyPolicyAssignUserDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./PayslipHourlyPolicyAssignUserDetailsView.vue?vue&type=style&index=0&id=52048cf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports